import React, {Fragment, useEffect, useRef, useState} from "react";
import {InfiosContainer} from '../../utils/styled/_grid.style';
import {colors} from '../../utils/styled/_variables.styled';
import Button from "../Button/Button";
import Icon from '../Icon/Icon';
import Loading from "../Loading/Loading";
import ThankYouMessage from "../ThankYouMessage/ThankYouMessage";
import {InfiosContactFormOverlay, InfiosContactFormTab} from "./ContactFormOverlay.style";
import axios from "axios";
import FormContainer from "../Form/Container";

const ContactFormOverlay = (props) => {
    const {
        className,
        open,
        close,
        contactTitle,
        contactText,
        thankYouTitle,
        thankYouText,
        emailText,
        emailIcon,
        contactForm,
        captchaConfig,
        pageLanguage,
        formBaseColor,
        formSubmitButton,
        tabTitle,
				formLinksColor
    } = props;


    const tabs = [{tabTitle: emailText, tabIcon: emailIcon}];
    // Will have two new tabs: "Chat with me" - Icon: "chat" || "Schedule a call" - Icon: "call"

    const ref = useRef(null);
    const scrollRef = useRef(null);

    const [hasOverflow, setHasOverflow] = useState(false);
    const [hasScrolled, setHasScrolled] = useState(false);
    const [selectedFormTab, setSelectedFormTab] = useState('id-tab-0');
    const [showLeftGradient, setShowLeftGradient] = useState(false);
    const [showRightGradient, setShowRightGradient] = useState(true);
    const [showThankYouMessage, setShowThankYouMessage] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [form, setForm] = useState(<></>);

    useEffect(() => {
        axios.get(contactForm + ".model.json").then(r => {
          let data = r.data[":items"].root[":items"].container;
          setForm(<FormContainer  cqItemsOrder={data[":itemsOrder"]}
                                  cqItems={data[":items"]}
                                  ThankYouWatcher={setShowThankYouMessage}
                                  LoadingWatcher={showLoading}
                                  captchaConfig={captchaConfig}
                                  pageLanguage={pageLanguage}
          />)
        })
    }, []);

    useEffect(() => {
        if (!ref?.current) return;
        handleResize();
        window.addEventListener('resize', handleResize);
        ref.current.addEventListener('scroll', handleScrollTabs);

        return () => {
            ref.current.removeEventListener('scroll', handleScrollTabs);
            window.removeEventListener('resize', handleResize);
        };
    }, [ref]);

    useEffect(() => {
        if (!scrollRef?.current) return;

        scrollRef.current.addEventListener('scroll', handleScrollOverlay);

        return () => {
            scrollRef.current.removeEventListener('scroll', handleScrollOverlay);
        };
    }, [scrollRef]);

    const handleCloseButton = () => {
        const urlParams = new URLSearchParams(window.location.search);

        sessionStorage.clear();
        setShowLoading(false);
        setShowThankYouMessage(false);
        close();
        if(urlParams.get('submit') != null) {
            urlParams.delete('submit');
            window.location.href = window.location.pathname + '?' + urlParams.toString();
        }
    }


    const handleFormTab = (buttonName) => {
        setSelectedFormTab(buttonName);
    };

    const handleResize = () => {
        if (ref.current) {
            const hasOverflow = ref.current.scrollWidth > ref.current.clientWidth;
            setHasOverflow(hasOverflow);
        }
    };

    const handleScrollOverlay = () => {
        setHasScrolled(scrollRef.current.scrollTop > 100)
    }

    const handleScrollTabs = () => {
        const scrollLeft = ref.current.scrollLeft;
        const scrollWidth = ref.current.scrollWidth;
        const clientWidth = ref.current.clientWidth;
        setShowLeftGradient(!!scrollLeft)
        setShowRightGradient(scrollLeft !== scrollWidth - clientWidth)
    }

    const contentSelector = (content) => {
        switch (content) {
            case "id-tab-0":
                return (
                    form
                );
            // Future tabs content will be added here.
            default:
                return <></>
        }
    }

    return (<>
        <InfiosContactFormOverlay
            className={`${hasScrolled ? "fixed" : ""} ${className} contact-form-overlay`}
            open={open}
            ref={scrollRef}
            showLeftGradient={showLeftGradient}
            showRightGradient={showRightGradient}
            hasOverflow={hasOverflow}
            formBaseColor={formBaseColor}
            formSubmitButton={formSubmitButton} 
            tabTitle={tabTitle}
						formLinksColor={formLinksColor}>
            <InfiosContainer>
                <Button className={"close close-uncollapsed"} onClick={() => handleCloseButton()} tertiary icon="close" />
                <section className="overlay-wrapper">
                    <span className="heading-2">{contactTitle || "How may we contact you?"}</span>
                    <p className="lead">{contactText || "Infios can help you achieve a breakthrough in your supply chain. Tell us about your projects and we will be in touch shortly."}</p>
                    <Button className={"close close-collapsed"} onClick={() => handleCloseButton()} tertiary icon="close" />
                </section>
                <section className="tabs-wrapper" ref={ref}>
                    {tabs?.map(({ tabTitle, tabIcon }, index) => {
                        return <InfiosContactFormTab key={`key-tab-${index}`} formBaseColor={formBaseColor}>
                            <span className={`link-button ${selectedFormTab === ('id-tab-' + index) ? 'open' : ''}`} onClick={() => handleFormTab(`id-tab-${index}`)}>{tabTitle} <Icon icon={tabIcon} color={colors.gray3} /></span>
                        </InfiosContactFormTab>
                    })}
                </section>
                <section className="content-wrapper">
                    {tabs?.map((tab, index) => {
                        return <Fragment key={`key-tab-${index}`}>
                            {selectedFormTab === `id-tab-${index}` && <div className="tab-content">
                                {contentSelector(`id-tab-${index}`)}
                            </div>}
                        </Fragment>
                    })}
                </section>
            </InfiosContainer>
        </InfiosContactFormOverlay>
        {showThankYouMessage && <ThankYouMessage thankYouTitle={thankYouTitle} thankYouText={thankYouText}/>}
        {showLoading && <Loading />}
    </>)
}

export default ContactFormOverlay;
